import {Box, Stack} from '@mui/material';
import {Typography, Divider} from '@mui/material';

import PageContents from 'components/PageContents';
import PageImage from 'components/PageImage';
import { ProjectCategory, ProjectInfo, projects_ } from 'data/projects';
import theme_ from 'theme/CurrentTheme';

const description = `Check out my software projects, programming, R&D, filmmaking.
Here you will find several of my projects, libraries, tools, research articles, etc.
`;


export default function HomePage() {
    return <PageContents title='Welcome' description={description}>

        <Box sx={{
            maxWidth: theme_.pageContentsWidth,
        }}>

        {/* <Stack direction='column'> */}
            {projects_.categories.map((item, index) => RenderProjectCategory(item, index))}
        {/* </Stack> */}
        </Box>

    </PageContents>
}

function RenderProjectCategory(cat: ProjectCategory, index: number) {
    return <Box key={cat.tag}>
        {index > 0 && <Divider/>}
        <Typography align='center' sx={{
            pt: 1,
            pb: 2,
            fontSize: 'x-large',
        }}>{cat.title}</Typography>

        {cat.projects.map((item, idx) => RenderProjectSection(item, idx))}
    </Box>;
}


function RenderProjectSection(proj: ProjectInfo, index: number) {
    return <Box key={proj.tag}>
        {index > 0 && <Divider/>}

        <Stack direction='row'>
            {proj.iconUrl && <PageImage width={theme_.projIconSize} src={proj.iconUrl}/>}
            {proj.iconsUrls && <>
                {proj.iconsUrls.map((icon, idx) => <PageImage key={idx} width={theme_.projIconSize} src={icon}/>)}
            </>}
            <Typography>{proj.title}</Typography>
        </Stack>

        <Typography>{proj.description}</Typography>
    </Box>;
}

